module.exports = __webpack_public_path__ + "static/media/construction_white_on_red_24dp.0c4db332.svg";